import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.35 4.85a.825.825 0 0 0-.825-.825H3.475a.825.825 0 0 0-.825.825v1.1c0 .456.37.825.825.825h17.05c.456 0 .825-.37.825-.825zM1 5.95c0 .972.56 1.813 1.375 2.218V19.15a2.475 2.475 0 0 0 2.475 2.475h14.3a2.475 2.475 0 0 0 2.475-2.475V8.168A2.48 2.48 0 0 0 23 5.95v-1.1a2.475 2.475 0 0 0-2.475-2.475H3.475A2.475 2.475 0 0 0 1 4.85zm3.025 13.2V8.425h15.95V19.15c0 .456-.37.825-.825.825H4.85a.825.825 0 0 1-.825-.825m11-7.425a.825.825 0 0 0-.825-.825H9.8a.825.825 0 0 0 0 1.65h4.4c.456 0 .825-.37.825-.825",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }